'use client';

import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '@/utils';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    container?: TooltipPrimitive.TooltipPortalProps['container'];
  }
>(({ className, sideOffset = 4, container, ...props }, ref) => {
  return (
    <TooltipPrimitive.Portal container={container}>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          'mm:z-50 mm:overflow-hidden mm:rounded-md mm:border mm:bg-popover mm:px-3 mm:py-1.5 mm:text-xs mm:text-popover-foreground mm:shadow-md mm:animate-in mm:fade-in-0 mm:zoom-in-95 mm:data-[state=closed]:animate-out mm:data-[state=closed]:fade-out-0 mm:data-[state=closed]:zoom-out-95 mm:data-[side=bottom]:slide-in-from-top-2 mm:data-[side=left]:slide-in-from-right-2 mm:data-[side=right]:slide-in-from-left-2 mm:data-[side=top]:slide-in-from-bottom-2',
          className
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
